import { memo } from "react";

import { DesignMagazineRoomArticleDefaultEditContainer } from "./container";

type Props = {
	hotelID: string;
	roomID: string;
};

export const DesignMagazineRoomArticleDefaultEdit = memo(({ hotelID, roomID }: Props) => {
	return <DesignMagazineRoomArticleDefaultEditContainer hotelID={hotelID} roomID={roomID} />;
});

DesignMagazineRoomArticleDefaultEdit.displayName = "DesignMagazineRoomArticleDefaultEdit";
